export function Footer() {
  return (
    <footer className="bg-canvas text-ink-soft py-16 border-t border-hairline">
      <div className="max-w-5xl mx-auto px-4 sm:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <img
                src="/landing/logo.jpeg"
                alt="智因错题本"
                className="w-10 h-10 rounded-md object-cover"
              />
              <span className="text-heading-sm text-ink">智因错题本</span>
            </div>
            <p className="text-body text-ink-soft max-w-md">
              错一道，会一道。拍照传错题，AI 帮你找出错因，再出题练到会。
            </p>
          </div>

          {/* Product */}
          <div>
            <h4 className="text-label text-ink mb-4">产品</h4>
            <ul className="space-y-3">
              <li>
                <a href="#loop" className="text-body text-ink-soft hover:text-ink transition-colors">
                  学习闭环
                </a>
              </li>
              <li>
                <a href="#xiaozhi" className="text-body text-ink-soft hover:text-ink transition-colors">
                  小智 AI 学伴
                </a>
              </li>
              <li>
                <a href="#features" className="text-body text-ink-soft hover:text-ink transition-colors">
                  功能介绍
                </a>
              </li>
              <li>
                <a href="#platforms" className="text-body text-ink-soft hover:text-ink transition-colors">
                  下载应用
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-label text-ink mb-4">关于</h4>
            <ul className="space-y-3">
              <li>
                <a href="/privacy" className="text-body text-ink-soft hover:text-ink transition-colors">
                  隐私政策
                </a>
              </li>
              <li>
                <a href="/terms" className="text-body text-ink-soft hover:text-ink transition-colors">
                  用户协议
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-hairline pt-8 space-y-4">
          <div className="text-center space-y-2">
            {/* W7C12-02（T-8096）：单 ICP——京ICP备16054801号-9 的备案归属与域名口径
                见 ops/PRODUCTION_MIGRATION_PLAN.md（明文归属，域名不在代码注释复述）；
                「京ICP备2026000127号-1X」在仓无归属证据且尾缀疑录错（runbook 记「-1」），
                待备案库核验后再定去留。 */}
            <p className="text-caption text-ink-soft">
              <a
                href="https://beian.miit.gov.cn/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-ink transition-colors"
              >
                京ICP备16054801号-9
              </a>
            </p>
          </div>
          <p className="text-caption text-ink-soft text-center">
            © {new Date().getFullYear()} 智因错题本. 保留所有权利.
          </p>
        </div>
      </div>
    </footer>
  )
}
